import { useEffect } from 'react';

interface SEOSchemaProps {
  type: 'home' | 'faq';
}

export const SEOSchema = ({ type }: SEOSchemaProps) => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://aplconsulttec.com.br';
    
    // Remove existing schema scripts
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => script.remove());

    if (type === 'home') {
      // Professional Service Schema
      const professionalServiceSchema = {
        "@context": "https://schema.org",
        "@type": "ProfessionalService",
        "name": "APL Consultoria e Assessoria Técnica Ltda",
        "description": "Certificação e assessoria técnica especializada em INMETRO, ANATEL, ANVISA e registro de fornecedores",
        "url": siteUrl,
        "telephone": "+55-21-99319-7442",
        "email": "comercial@aplconsulttec.com.br",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Rio de Janeiro",
          "addressRegion": "RJ",
          "addressCountry": "BR"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "-22.9068",
          "longitude": "-43.1729"
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        "areaServed": {
          "@type": "Country",
          "name": "Brasil"
        },
        "image": "https://static.readdy.ai/image/a19dd0a56f3d184158c62a348fccb582/b22abf83f98c1a1bdbbfebb3a321b34b.jpeg"
      };

      // Organization Schema
      const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "APL Consultoria e Assessoria Técnica Ltda",
        "url": siteUrl,
        "logo": "https://static.readdy.ai/image/a19dd0a56f3d184158c62a348fccb582/b22abf83f98c1a1bdbbfebb3a321b34b.jpeg",
        "image": "https://static.readdy.ai/image/a19dd0a56f3d184158c62a348fccb582/b22abf83f98c1a1bdbbfebb3a321b34b.jpeg",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+55-21-99319-7442",
          "contactType": "customer service",
          "email": "comercial@aplconsulttec.com.br",
          "availableLanguage": "Portuguese"
        },
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Rio de Janeiro",
          "addressRegion": "RJ",
          "addressCountry": "BR"
        }
      };

      // WebSite Schema
      const websiteSchema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "APL Consultoria e Assessoria Técnica",
        "url": siteUrl,
        "description": "Certificação INMETRO, homologação ANATEL, registro ANVISA e consultoria técnica especializada",
        "publisher": {
          "@type": "Organization",
          "name": "APL Consultoria e Assessoria Técnica Ltda"
        }
      };

      // Service Schema
      const serviceSchema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Consultoria em Certificação e Conformidade",
        "provider": {
          "@type": "Organization",
          "name": "APL Consultoria e Assessoria Técnica Ltda"
        },
        "areaServed": {
          "@type": "Country",
          "name": "Brasil"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Serviços de Certificação",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Certificação INMETRO",
                "description": "Apoio completo no processo de certificação INMETRO para seus produtos"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Homologação ANATEL",
                "description": "Assessoria especializada para homologação de produtos junto à ANATEL"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Registro ANVISA",
                "description": "Suporte técnico para registro de produtos na ANVISA"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Registro de Fornecedores",
                "description": "Assessoria para registro de fornecedores e fabricantes"
              }
            }
          ]
        }
      };

      // LocalBusiness Schema
      const localBusinessSchema = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "APL Consultoria e Assessoria Técnica Ltda",
        "image": "https://static.readdy.ai/image/a19dd0a56f3d184158c62a348fccb582/b22abf83f98c1a1bdbbfebb3a321b34b.jpeg",
        "url": siteUrl,
        "telephone": "+55-21-99319-7442",
        "email": "comercial@aplconsulttec.com.br",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "",
          "addressLocality": "Rio de Janeiro",
          "addressRegion": "RJ",
          "postalCode": "",
          "addressCountry": "BR"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": -22.9068,
          "longitude": -43.1729
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        ],
        "priceRange": "$$"
      };

      const schemas = [professionalServiceSchema, organizationSchema, websiteSchema, serviceSchema, localBusinessSchema];
      
      schemas.forEach(schema => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(schema);
        document.head.appendChild(script);
      });
    }
  }, [type]);

  return null;
};
